import { FC, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { CustomerSupport, MemberCardBack, MemberCardFront, ThemedButton, UnifiedInformation } from "@/App/components";
import { SearchParamKeys } from "@/App/constants/constants";
import { ExperienceContext } from "@/App/context";
import { MemberEligibilityContext } from "@/App/context/MemberEligibilityContext";
import { useIsUnifiedUser, useNavigateClientNewTab } from "@/App/hooks";

export const PlanDetailsPanel: FC = () => {
  const { t: translate } = useTranslation();

  const { memberEligibility, isViewingDataholder } = useContext(MemberEligibilityContext);
  const { hideMemberCard, hideCustomerCarePhoneNumber } = useContext(ExperienceContext);

  const { isUnifiedUser } = useIsUnifiedUser();

  const { gridSpan } = useResponsive({
    gridSpan: {
      mobile: 12,
      desktop: 6,
    },
  });

  const navigate = useNavigateClientNewTab();

  const onPrintCardPressed = useCallback(() => {
    if (isViewingDataholder) {
      const newParams = new URLSearchParams();
      newParams.append(SearchParamKeys.MEMBER_ELIGIBILITY_MEMBER_ID, memberEligibility.member.id.toString());
      navigate("/id_card", newParams);
    } else {
      navigate("/id_card");
    }
  }, []);

  return (
    <Grid>
      {!hideMemberCard && (
        <Grid.Span columns={hideCustomerCarePhoneNumber ? 12 : gridSpan}>
          <Stack testId="member-card-container">
            <Shelf alignment="center">
              <MemberCardFront />
            </Shelf>
            {isUnifiedUser && (
              <Shelf alignment="center">
                <MemberCardBack />
              </Shelf>
            )}
            <Shelf alignment="center">
              <ThemedButton icon="print" testId="print-card" appearance="secondary" onClick={onPrintCardPressed}>
                {translate("DASHBOARD.planDetailsPanel.printCard")}
              </ThemedButton>
            </Shelf>
          </Stack>
        </Grid.Span>
      )}
      {!isUnifiedUser && !hideCustomerCarePhoneNumber && (
        <Grid.Span columns={hideMemberCard ? 12 : gridSpan}>
          <CustomerSupport />
        </Grid.Span>
      )}
      {isUnifiedUser && (
        <Grid.Span columns={hideMemberCard ? 12 : gridSpan}>
          <UnifiedInformation />
        </Grid.Span>
      )}
    </Grid>
  );
};
